import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import { BASE_URL, security_key } from "../../../global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Logo from "../../../Assets/img/the-paperboy-logo-5.png"
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import LinearProgress from "@mui/material/LinearProgress";

const InviteFriend = ({ closeModal, getAllInvitedFriends, invitedList = [] }) => {
    const navigate = useNavigate();
    const formRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showNavBar, setShowNavbar] = useState(true);

    const user_key = sessionStorage.getItem("pk_user_key");

    const reverseString = (str) => {
        if (!str) return "";
        return str.split("").reverse().join("");
    };
    const reversedKey = reverseString(user_key);
    // const referralcode = btoa(reversedKey);
    const referralcode = reversedKey;


    console.log('invitedList', invitedList)

    const initialValues = {
        first_name: "",
        last_name: "",
        user_email: "",
        password: "",
        phone: "",
        address_line1: "",
        address_line2: "",
        country: "",
        state: "",
        city: "",
        zip_code: "",
        created_by: "",
        user_status: "1",
    };

    const basicSchema = Yup.object().shape({



        first_name: Yup.string()
            .required("First Name is required.")
            .test("no-leading-space", "No spaces allowed at the beginning.", function (value) {
                if (!value) return true;
                return !/^\s/.test(value);
            })
            .min(3, "Minimum 3 characters.")
            .max(50, "Maximum 50 characters.")
            .test("no-trailing-space", "No spaces allowed at the end.", function (value) {
                if (!value) return true;
                return !/\s$/.test(value);
            })
            .matches(/^[a-zA-Z]*$/, "First Name can only contain letters."),

        last_name: Yup.string()
            .required("Last Name is required.")
            .test("no-leading-space", "No spaces allowed at the beginning.", function (value) {
                if (!value) return true;
                return !/^\s/.test(value);
            })
            .min(1, "Minimum 1 characters.")
            .max(250, "Maximum 50 characters.")
            .test("no-trailing-space", "No spaces allowed at the end.", function (value) {
                if (!value) return true;
                return !/\s$/.test(value);
            })
            .matches(/^[a-zA-Z]*$/, "Last Name can only contain letters."),



        address_line1: Yup.string().max(100, "Address Line 1 must be at most 100 characters.").required("Address Line 1 is required."),

        address_line2: Yup.string().max(100, "Address Line 2 must be at most 100 characters."),

        country: Yup.string().max(50, "Country must be at most 50 characters.").required("Country is required."),

        city: Yup.string().max(50, "City must be at most 50 characters.").required("City is required."),

        state: Yup.string().max(50, "State must be at most 50 characters.").required("State is required."),

        zip_code: Yup.string()
            .matches(/^\d{5}(-\d{4})?$/, "Zipcode must be a 5-digit number or a 5+4 format (e.g., 12345 or 12345-6789).")
            .required("Zipcode is required."),

        user_email: Yup.string()
            .email("Invalid email address.")
            .required("email is required."),


        phone: Yup.string()
            .required("Phone number is required.")
            .min(11, "Phone number must be at least 10 digits.")
            .max(16, "Phone number must not exceed 15 digits.")
            .test("unique-digits", "Invalid phone number.", function (value) {
                const cleanedDigits = value.replace(/^\+\D*/, "");
                const digitsWithoutCountryCode = cleanedDigits.slice(1);
                const hasDifferentDigit = Array.from(new Set(digitsWithoutCountryCode)).length !== 1;
                return hasDifferentDigit || this.createError({ message: "Invalid phone number." });
            }),
    });


    const formik = useFormik({
        initialValues,
        validationSchema: basicSchema,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            toast.dismiss();

            setIsSubmitting(true);

            const response = await axios.post(
                BASE_URL + "API/apicall",
                {
                    security_key: security_key,
                    mode: "InviteFriendData",
                    ...formValues,
                },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            const output = response.data;
            if (output == 1) {
                getAllInvitedFriends();
                toast.success("Added successfully!", {
                    autoClose: 3000,
                });
                 setTimeout(() => closeModal(), 500);
            } else {
                toast.error("Oops! Something went wrong.", {
                    autoClose: 3000,
                });
            }
            setTimeout(function () {
                setIsSubmitting(false);
            }, 3000);
        },
    });

    // const handleInviteSubmit = async (e) => {
    //     e.preventDefault();
    //     toast.dismiss();
    //     setIsSubmitting(true);

    //     const user_key = sessionStorage.getItem("pk_user_key");
    //     const reverseString = (str) => (str ? str.split("").reverse().join("") : "");
    //     const referralcode = reverseString(user_key);

    //     const payload = {
    //         security_key: security_key,
    //         mode: "sendToplineInvLinkEmail",
    //         first_name: values.first_name,
    //         last_name: values.last_name,
    //         email: values.user_email,
    //         phone: values.phone,
    //         created_by: user_key,
    //         referral_code: referralcode,
    //         link: `${BASE_URL}signup-form?ref=${referralcode}`,
    //         // link: `http://localhost:3000/2024/paperboy/signup-form?ref=${referralcode}`,
    //     };

    //     try {
    //         const res = await axios.post(`${BASE_URL}API/apicall`, payload);
    //         const output = res.data;

    //         if (output === 1) {
    //             toast.success("Invitation email sent successfully!");
    //             if (typeof closeModal === "function") closeModal();
    //         } else {
    //             toast.error("Failed to send invitation email.");
    //         }
    //     } catch (error) {
    //         console.error("Error sending invitation:", error);
    //         toast.error("Error sending invitation email.");
    //     } finally {
    //         setIsSubmitting(false);
    //     }
    // };



    const handleInviteSubmit = async (e) => {
        e.preventDefault();
        toast.dismiss();
        setIsSubmitting(true);

        const user_key = sessionStorage.getItem("pk_user_key");
        const reverseString = (str) => (str ? str.split("").reverse().join("") : "");
        const referralcode = reverseString(user_key);

        const alreadyInvited = (invitedList || []).some(
            (friend) =>
                friend.email?.toLowerCase() === values.user_email.toLowerCase() &&
                friend.referral_code === referralcode
        );

        if (alreadyInvited) {
            toast.warning("This user is already invited by you.");
            setIsSubmitting(false);
            return;
        }

        const payload = {
            security_key: security_key,
            mode: "sendToplineInvLinkEmail",
            first_name: values.first_name,
            last_name: values.last_name,
            email: values.user_email,
            phone: values.phone,
            created_by: user_key,
            referral_code: referralcode,
            link: `${BASE_URL}signup-form?ref=${referralcode}`,
        };

        try {
            const res = await axios.post(`${BASE_URL}API/apicall`, payload);
            const output = res.data;

            if (output === 1) {
                getAllInvitedFriends();
                toast.success("Invitation email sent successfully!", {
                    autoClose: 3000,
                });
                 setTimeout(() => closeModal(), 500);
            } else {
                toast.error("Failed to send invitation email.");
            }
        } catch (error) {
            console.error("Error sending invitation:", error);
            toast.error("Error sending invitation email.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const { values, handleChange, handleBlur, touched, errors, handleSubmit, setFieldValue, resetForm, setValues, setTouched } = formik;

    return (
        <>

            <section className="pb-3 d-flex justify-content-center align-items-center">
                <div className="main-content w-100 d-flex flex-column align-items-center">
                    <form
                        onSubmit={handleInviteSubmit}
                        ref={formRef}
                        className="w-100 d-flex flex-column align-items-center"
                    >
                        <div
                            className="card shadow-sm mb-3"
                            style={{
                                width: "600px",
                                borderRadius: "16px",
                            }}
                        >
                            <div className="card-body p-5">
                                <h4 className="text-center mb-4">General Information</h4>

                                <div className="form-group mb-3">
                                    <label className="form-label mb-1">
                                        First Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control bg-7"
                                        name="first_name"
                                        value={values.first_name}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter first name"
                                    />
                                    {errors.first_name && touched.first_name && (
                                        <p className="error-msg text-danger">{errors.first_name}</p>
                                    )}
                                </div>

                                <div className="form-group mb-3">
                                    <label className="form-label mb-1">
                                        Last Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control bg-7"
                                        name="last_name"
                                        value={values.last_name}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter last name"
                                    />
                                    {errors.last_name && touched.last_name && (
                                        <p className="error-msg text-danger">{errors.last_name}</p>
                                    )}
                                </div>

                                <div className="form-group mb-3">
                                    <label className="form-label mb-1">
                                        Email Address <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        className="form-control bg-7"
                                        name="user_email"
                                        value={values.user_email}
                                        onChange={handleChange}
                                        // onBlur={handleBlur}
                                        onBlur={(e) => {
                                            handleBlur(e);
                                            const enteredEmail = e.target.value.toLowerCase();
                                            const alreadyInvited = invitedList.some(
                                                (f) => f.email?.toLowerCase() === enteredEmail && f.referral_code === referralcode
                                            );
                                            if (alreadyInvited) {
                                                toast.warning("This user is already invited by you.");
                                            }
                                        }}
                                        placeholder="Enter email"
                                    />
                                    {errors.user_email && touched.user_email && (
                                        <p className="error-msg text-danger">{errors.user_email}</p>
                                    )}
                                </div>

                                <div className="form-group mb-2">
                                    <label className="form-label mb-1">
                                        Phone Number <span className="text-danger">*</span>
                                    </label>
                                    <PhoneInput
                                        inputClass="form-control bg-7"
                                        id="phone"
                                        name="phone"
                                        countryCodeEditable={false}
                                        country="us"
                                        value={values.phone}
                                        onlyCountries={["us"]}
                                        onChange={(value, data) => setFieldValue("phone", value)}
                                        onBlur={(e) => {
                                            const event = { target: { name: "phone", value: e.target.value } };
                                            handleBlur(event);
                                            setTouched({ ...touched, phone: true });
                                        }}
                                    />
                                    {errors.phone && touched.phone && (
                                        <p className="error-msg text-danger">{errors.phone}</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="text-center mt-3">
                            <button
                                type="submit"
                                className="btn text-white btn-dark rounded-3 px-5 py-3 fs-6"
                            >
                                Invite Friend
                                {isSubmitting && <LinearProgress />}
                            </button>
                        </div>
                    </form>
                </div>

                <style jsx>{`
        .form-group {
          display: flex;
          flex-direction: column;
        }

        .form-label {
          font-weight: 500;
          margin-bottom: 4px !important;
        }

        .form-control {
          padding: 10px 14px;
          font-size: 15px;
        }

        .error-msg {
          font-size: 12px;
          margin-top: 2px;
        }

        .card-body {
          padding: 36px;
        }

        button.btn {
          min-width: 180px;
        }
      `}</style>
            </section>
        </>
    );




};

export default InviteFriend;
